import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";

import { getSafeAreaPaddings } from "../../utils/getSafeAreaPaddings";
import { HelpAndSupport } from "./HelpAndSupport";
import { Info } from "./Info";
import { ViewInvitesButton } from "./ViewInvitesButton";

interface InviteRequiredPageContentProps {
  clipboardScore: number;
  invitesCount: number;
  onRefresh: () => Promise<void>;
}

export function InviteRequiredPageContent(props: InviteRequiredPageContentProps) {
  const { clipboardScore, invitesCount, onRefresh } = props;

  return (
    <Stack
      flex={1}
      overflow="hidden"
      position="relative"
      sx={{
        ...getSafeAreaPaddings({
          top: true,
          bottom: true,
        }),
        background: "linear-gradient(353deg, #FBF2E8 37.36%, #F7D0D0 111.62%)",
      }}
    >
      <PullToRefresh onRefresh={onRefresh} />

      <Box sx={{ flex: "1", overflow: "auto", pb: 10 }}>
        <Stack flex={1} spacing={7} p={5} pt={10}>
          <Text variant="h2" textAlign="center" color={(theme) => theme.palette.error.main}>
            Your account is{" "}
            <Text noWrap inline variant="h2" color={(theme) => theme.palette.error.main}>
              invite-required
            </Text>
          </Text>
          <Info clipboardScore={clipboardScore} />
          <HelpAndSupport />
        </Stack>
      </Box>

      <ViewInvitesButton invitesCount={invitesCount} />
    </Stack>
  );
}
